import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/collective/page.js");
